import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { publicFile } from "@/components/landing/LandingData";

const INTERVAL = 5000;

const Arrow = ({ dir, onClick }) => {
  const Icon = dir === "prev" ? ChevronLeft : ChevronRight;
  return (
    <button onClick={onClick} aria-label={dir === "prev" ? "Immagine precedente" : "Immagine successiva"} data-testid={`hero-${dir}-button`}
      className={`absolute top-1/2 -translate-y-1/2 ${dir === "prev" ? "left-3 sm:left-6" : "right-3 sm:right-6"} z-10 h-11 w-11 rounded-full hidden sm:grid place-items-center bg-white/15 backdrop-blur-md text-white hover:bg-white/30 transition-colors`}>
      <Icon className="h-6 w-6" />
    </button>
  );
};

export const HeroSlider = ({ classi }) => {
  const slides = classi.filter((c) => c.home_foto_id).map((c) => ({ src: publicFile(c.home_foto_id), label: c.categoria }));
  const list = slides.length ? slides : [{ src: "/home-hero.jpg", label: "" }];
  const n = list.length;
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const ref = useRef(null);
  const go = (k) => setI(((k % n) + n) % n);
  useEffect(() => {
    const el = ref.current?.parentElement;
    if (!el || n < 2) return undefined;
    let x0 = null;
    const start = (e) => { x0 = e.touches[0].clientX; };
    const end = (e) => {
      const dx = e.changedTouches[0].clientX - (x0 ?? 0);
      if (x0 !== null && Math.abs(dx) > 40) setI((x) => (((x + (dx < 0 ? 1 : -1)) % n) + n) % n);
      x0 = null;
    };
    el.addEventListener("touchstart", start, { passive: true });
    el.addEventListener("touchend", end);
    return () => {
      el.removeEventListener("touchstart", start);
      el.removeEventListener("touchend", end);
    };
  }, [n]);
  useEffect(() => {
    if (n < 2 || paused) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), INTERVAL);
    return () => clearInterval(t);
  }, [n, paused, i]);
  return (
    <div ref={ref} className="absolute inset-0" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div className="flex h-full transition-transform duration-700 ease-out" style={{ transform: `translateX(-${i * 100}%)` }} data-testid="hero-slider-track">
        {list.map((s, k) => (
          <img key={s.src} src={s.src} alt={s.label} data-testid={`hero-slide-${k}`} className="w-full h-full object-cover shrink-0" />
        ))}
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C] via-[#0B192C]/50 to-[#0B192C]/30 pointer-events-none" />
      {n > 1 && (
        <>
          <Arrow dir="prev" onClick={() => go(i - 1)} />
          <Arrow dir="next" onClick={() => go(i + 1)} />
          <div className="absolute bottom-6 right-5 sm:right-8 z-10 flex items-center gap-2" data-testid="hero-slider-dots">
            {list.map((s, k) => (
              <button key={s.src} onClick={() => go(k)} aria-label={s.label} data-testid={`hero-dot-${k}`}
                className={`h-2 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-8 bg-white" : "w-2 bg-white/50 hover:bg-white/80"}`} />
            ))}
            <span className="ml-2 font-heading uppercase tracking-wider text-white/80 text-sm" data-testid="hero-slide-label">{list[i]?.label}</span>
          </div>
        </>
      )}
    </div>
  );
};
